<template>
    <div class="login-container" v-if="!resetPasswordCompleted">
        <a href="/">
            <div class="logo-img"></div>
        </a>
        <h2>Forgot Password</h2>

        <div class="login-inner-container">
            <div class="forgotpass-subtitle">Enter the email address you used to sign up and we'll send you a new
                password.
            </div>

            <v-flex>
                <span class="login-label">Email *</span>
                <v-text-field
                    v-model="resetPasswordEmail"
                    class="email-input"
                    :rules="[rules.required, rules.emailValid]"
                ></v-text-field>
            </v-flex>

            <v-flex>
                <v-btn class="submit login-submit" v-on:click="() => resetPassword()">Reset password</v-btn>
            </v-flex>
        </div>

        <div class="footer-links">
            <div class="footer-link">
                <div class="forgot-pass">
                    <nuxt-link :to="localePath('/login')">Login</nuxt-link>
                    <div class="link-border"></div>
                </div>
            </div>
            <div class="footer-link text-center">
                <div class="terms">
                    <nuxt-link :to="localePath('/terms-and-conditions')">Terms and conditions</nuxt-link>
                    <div class="link-border"></div>
                </div>
            </div>
            <div class="footer-link text-right">
                <div class="create-account">
                    <nuxt-link class="ga4-reg-btn" :to="localePath('/register')">Create account</nuxt-link>
                    <div class="link-border"></div>
                </div>
            </div>
        </div>
    </div>
    <div class="login-container login-container-success" v-else>
        <a href="/">
            <div class="logo-img"></div>
        </a>
        <div v-if="resetPasswordSuccess">
            <h2>Check your mail</h2>
            <div class="additional-info">
                Follow the link sent to your email to set your new password.
            </div>
            <button class="submit login-submit" v-on:click="$router.push(localePath({ path: '/login'}))">Go to Login
            </button>
        </div>
        <div v-else>
            <h2>Password reset failed!</h2>
            <div class="additional-info">
                Please go back and check your email once again!
            </div>
            <button class="submit login-submit" v-on:click="resetForm">Try again</button>
        </div>
    </div>
</template>


<script>
    import {required, email} from 'vuelidate/lib/validators';
    import axios from "axios";

    export default {
        name: "Forgotpassword",
        validations: {
            resetPasswordEmail: {
                required,
                email
            }
        },
        head: {
            title: 'Forgot password | Fine Wine Trading App',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
                }
            ],
        },
        data() {
            return {
                resetPasswordEmail: "",
                resetPasswordCompleted: false,
                resetPasswordSuccess: false,
                resetPasswordFail: false,
                rules: {
                    required: value => !!value || 'Required.',
                    min: value => value.length >= 8 || 'Min 8 characters',
                    emailValid: value => this.isEmailValid(value) || 'Invalid email'

                },
                valid: true,
                reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
            }
        },
        methods: {
            isEmailValid: function (email) {
                return this.reg.test(email)
            },
            resetPassword() {
                let resetPassThis = this;

                if (this.resetPasswordEmail && !this.$v.resetPasswordEmail.$invalid) {
                    axios.post('https://auth.vindome.net/api/ResetPassword', {
                        email: this.resetPasswordEmail,
                        browser: 'Website'
                    }).then(function () {
                        resetPassThis.resetPasswordCompleted = true;
                        resetPassThis.resetPasswordSuccess = true;
                    }).catch(function () {
                        resetPassThis.resetPasswordCompleted = true;
                        resetPassThis.resetPasswordFail = true;
                    })
                }
            },
            resetForm() {
                this.resetPasswordCompleted = false;
                this.resetPasswordFail = false;
                this.resetPasswordSuccess = false;
            }
        }
    }
</script>

<style scoped>
    .login-container {
        text-align: center;
        padding: 0 calc(3 * var(--gutter)) calc(4 * var(--gutter));
    }

    .logo-img {
        background: url('../assets/v_dark.svg') no-repeat center 50px;
        background-size: contain;
        width: 300px;
        height: 180px;
        margin: 0 auto;
    }

    h2 {
        color: #707070;
        margin-bottom: calc(2 * var(--gutter));
    }

    .login-inner-container {
        max-width: 700px;
        background: #F5F6F5;
        border-radius: 10px;
        padding: 30px 50px 50px;
        margin: 0 auto;
        position: relative;
    }

    .login-label {
        position: absolute;
        font-size: var(--fs-base);
        color: #303030;
        font-weight: 300;
    }

    .login-container .submit {
        margin-top: 30px;
        background: #E1C376 !important;
        color: #FFF !important;
        width: 200px;
        height: 40px !important;
        font-size: 18px;
        border-radius: 5px;
        text-transform: none;
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        letter-spacing: 0;
        font-weight: lighter;
        box-shadow: none;
        margin-left: 0;
        margin-right: 0;
    }

    .footer-links {
        max-width: 700px;
        margin: 20px auto 0;
        display: flex;
    }

    .footer-link {
        display: inline-block;
        width: 33.33%;
    }

    .footer-links .terms {
        width: max-content;
        margin: 0 auto;
    }

    .footer-links .forgot-pass,
    .footer-links .create-account {
        width: max-content;
    }

    .footer-links .create-account {
        float: right;
    }

    .link-border {
        height: 1px;
        width: 100%;
        background: #707070;
    }

    .footer-links > div:hover .link-border {
        background: var(--brand);
    }

    .login-container-success {
        padding-top: 200px;
    }

    .additional-info {
        color: #707070;
        font-size: var(--fs-base);
        text-align: center;
    }

    .forgotpass-subtitle {
        max-width: 400px;
        margin: 0 auto;
    }

    @media (max-width: 767px) {
        h2 {
            font-weight: 300;
            font-size: 28px;
            line-height: 30px;
        }

        .login-container {
            padding: 0 15px 30px;
        }

        .logo-img {
            background: url('../assets/v_dark.svg') no-repeat center;
            background-size: contain;
            width: 170px;
            height: 80px;
        }

        .login-inner-container {
            padding: 30px 15px;
        }

        .footer-links {
            display: block;
        }

        .footer-link {
            display: block;
            width: 100%;
            text-align: center !important;
        }

        .footer-links .forgot-pass,
        .footer-links .create-account {
            width: 100%;
        }

        .link-border {
            height: 0;
        }

        .footer-links .create-account {
            float: none;
            margin-top: 5px;
        }

        .footer-links .terms {
            margin-top: 5px;
        }

        .login-container .submit {
            width: 100%;
        }
    }
</style>

<style>
    .loginpage .header-login-btn,
    .loginpage .header-register-btn,
    .loginpage .header-container {
        display: none;
    }

    .login-container .flex {
        margin-top: 20px;
        text-align: left;
    }

    .login-container .v-input input {
        height: 50px;
        max-height: unset;
        margin-top: 20px;
        padding-left: 15px;
    }

    .login-container .v-text-field .v-input__append-inner {
        margin-top: 20px;
        background: #fff;
        height: 50px;
    }

    .login-container .v-text-field .v-input__append-inner .v-input__icon {
        margin-top: 12px;
    }

    .login-container .v-text-field .v-input__append-inner .primary--text {
        color: #000 !important;
        caret-color: #000 !important;
    }

    .login-container .theme--light.v-input:not(.v-input--is-disabled) input {
        border: 0;
    }

    .login-container .theme--light.v-text-field:not(.v-input--has-state) > .v-input__control > .v-input__slot:hover:before {
        border-color: var(--brand);
    }

    .login-container .theme--light.v-text-field > .v-input__control > .v-input__slot:after {
        border-color: rgba(0, 0, 0, .87);
        border-width: 1px;
    }

    .login-container .theme--light.v-text-field.error--text > .v-input__control > .v-input__slot:after {
        border-color: #ff5252;
    }

    .login-container .footer-links a {
        text-decoration: none;
        color: #707070;
        font-size: 19px;
        font-weight: 300;
    }

    .login-container .footer-links a:hover {
        color: var(--brand);
    }

    .theme--light.v-application.loginpage {
        background: #ffffff;
    }
</style>
